import Splide from '@splidejs/splide';
var GLightbox = require('glightbox');
var splide = document.querySelectorAll('.splide.product-slider');
var productGallerySplide = document.getElementById('product-gallery-splide');
var initSplideProductSlider = function (id) {
    var splide = new Splide(id, {
        type: 'loop',
        pagination: true,
        paginationDirection: 'ltr',
        perPage: 6,
        perMove: 1,
        focus: 3,
        autoplay: true,
        arrows: false,
        slideFocus: true,
        breakpoints: {
            1200: {
                perPage: 4,
            },
            768: {
                perPage: 3,
            },
            568: {
                perPage: 2,
            },
        }
    });
    splide.mount();
};
var initGlideProductGallerySlider = function (element) {
    var numOfSlides = Number(element.getAttribute('data-number-of-slides'));
    var options = {
        type: 'loop',
        autoWidth: true,
        autoHeight: true,
        height: '464px',
        pagination: true,
        paginationDirection: 'ltr',
        autoplay: false,
        perPage: 4,
        perMove: 1,
        arrows: false,
        direction: 'ttb',
        slideFocus: true,
        fixedWidth: "111px",
        fixedHeight: "111px",
        gap: "5px",
        breakpoints: {
            1400: {
                direction: 'ltr',
                perPage: 4,
                perMove: 1,
                gap: '10px',
                width: '464px',
                height: '111px',
                autoWidth: false,
            },
            568: {
                direction: 'ltr',
                perPage: 2,
                perMove: 1,
                gap: '10px',
                autoWidth: false,
            }
        }
    };
    if (numOfSlides > 4) {
        options.autoplay = true;
    }
    var splide = new Splide(element, options);
    splide.mount();
    splide.on('click', function (e) {
        var Autoplay = splide.Components.Autoplay;
        Autoplay.pause();
        var index;
        if (!e.isClone) {
            index = e.index;
        }
        else {
            index = e.slideIndex;
        }
        initLightBoxSlider(splide, index);
    });
};
var initLightBoxSlider = function (splide, index) {
    var Autoplay = splide.Components.Autoplay;
    var slides = productGallerySplide.querySelectorAll('.splide__slide:not(.splide__slide--clone)');
    var data = Array.from(slides).map(function (slide) {
        return {
            source: slide.dataset.imgSrc,
            altText: slide.dataset.imgAlt,
            videoUrl: slide.dataset.videoUrl,
            type: slide.dataset.imgType,
        };
    });
    var lightbox = GLightbox({
        touchNavigation: true,
        loop: true,
        elements: data.map(function (slide) {
            if (slide.type === 'image') {
                return {
                    type: 'image',
                    href: slide.source,
                    alt: slide.altText,
                    width: '90%'
                };
            }
            else {
                return {
                    type: 'video',
                    href: slide.videoUrl,
                    source: 'youtube'
                };
            }
        })
    });
    lightbox.openAt(index);
    lightbox.on('close', function () {
        Autoplay.play();
    });
};
if (splide) {
    splide.forEach(function (slide) {
        initSplideProductSlider("#".concat(slide.dataset.id));
    });
}
if (productGallerySplide) {
    initGlideProductGallerySlider(productGallerySplide);
}
